import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgProfileAlt = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 7a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m-.713 9.413c-1.472.76-2.435 1.848-2.707 3.236q-.001.018 0 .018-.001.004.016.024A.22.22 0 0 0 4 19.75h16c.073 0 .128-.03.154-.059a.1.1 0 0 0 .016-.024q.002 0 0-.018c-.272-1.388-1.235-2.476-2.707-3.236-1.478-.764-3.415-1.163-5.463-1.163s-3.985.399-5.463 1.163m-.689-1.333c1.744-.9 3.931-1.33 6.152-1.33s4.409.43 6.152 1.33c1.75.905 3.106 2.32 3.49 4.281.216 1.106-.726 1.889-1.642 1.889H4c-.915 0-1.858-.783-1.642-1.889.384-1.962 1.74-3.376 3.49-4.28"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgProfileAlt;
